import { useContext } from "react";
import { useParams } from "react-router-dom";
import { buildASOPath } from "lib/resource-finder/resource-finder";
import { EOR_PROFILE_PATH } from "pages/employer-of-record/routes";
import { SUBPATHS } from "../constants";
import { useProfileContextData } from "../contexts/ProfileInfoContext";
import {
  NeonSkyContext,
  NeonSkyFeatureFlag,
} from "lib/neon-sky/neon-sky-provider";

/**
 * Hook to determine the correct redirect URL for EOR employee profile pages.
 * Returns the Neon Member Settings page URL if the feature flag is active,
 * otherwise returns the Clockface Employee Profile URL.
 */
export function useProfileRedirectUrl(): string {
  const { id: memberUuid } = useParams();
  const { featureFlags } = useContext(NeonSkyContext);
  const { memberCanonicalId } = useProfileContextData();

  const isNeonFeatureEnabled =
    featureFlags[NeonSkyFeatureFlag.PERMIT_EOR_IN_PERSONAL_INFORMATION];

  if (isNeonFeatureEnabled) {
    // Use the canonical member ID from the profile info
    return buildASOPath(`/member/${memberCanonicalId}/personal-info`);
  }

  // Default to the Clockface Employee Profile page
  return `/employer-of-record${EOR_PROFILE_PATH}/${memberUuid}/${SUBPATHS.PERSONAL_INFO}`;
}
